<template>
  <div
    style=""
    :class="['language-picker', 'mr-3', (dark ? 'dark' : null)]"
  >
    <span
      v-for="language in languages"
      :key="language.code"
    >
      <a
        :class="['language-item', ($i18n.locale() === language.code ? 'active' : '')]"
        @click="setLanguage(language.code)"
      >
        {{ language.label }}
      </a>
      {{ language.separator ? ' | ' : '' }}
    </span>
  </div>
</template>

<script>
  export default {
    name: "LanguagePicker",
    props: {
      dark: {
        type: Boolean,
        default: true,
      }
    },
    data() {
      return {
        languages: [
          { code: 'es', label: 'ES', separator: true },
          { code: 'en', label: 'EN', separator: false },
        ]
      };
    },
    methods: {
      setLanguage(lang) {
        this.$i18n.set(lang);
        this.axios.defaults.headers.common['Accept-Language'] = lang;
        window.localStorage.setItem('Language', lang);
      }
    }
  }
</script>

<style lang="scss">
  .language-picker {
    min-width: 100px;
    white-space: nowrap;
    margin-right: 1em;

    .language-item {
      &.active {
        font-weight: bold;
      }
      &:hover {
        cursor: pointer;
      }
    }

    &.dark {
      .language-item {
        color: white !important;
      }
    }
  }
</style>
